import { homeQueryKeys } from "@kovernow/flows/home";
import { profileQueryKeys } from "@kovernow/flows/profile";
import { useQuery } from "@tanstack/react-query";
import { useServices, useSession } from "./app-context";

/**
 * The signed-in account (name + email). After a reload the session holds
 * only the access token, so this asks `GET /users/`; until it answers (or
 * if it fails) the session's own user, when there is one, fills in.
 */
export function useAccountUser() {
  const { homeApi } = useServices();
  const { user: sessionUser } = useSession();
  const q = useQuery({ queryKey: homeQueryKeys.user(), queryFn: () => homeApi.user() });
  const name = q.data?.name ? [q.data.name, q.data.familyName].filter(Boolean).join(" ") : sessionUser?.name;
  return {
    query: q,
    account: q.data || sessionUser ? { name, email: q.data?.email ?? sessionUser?.email } : null,
  };
}

/**
 * The read-only profile, always fetched fresh (never served from cache):
 * staleTime 0 and gcTime 0, so leaving the screen drops it.
 */
export function useProfile() {
  const { profileApi } = useServices();
  return useQuery({
    queryKey: profileQueryKeys.profile(),
    queryFn: () => profileApi.profile(),
    staleTime: 0,
    gcTime: 0,
  });
}
